// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap';

export default class InfographicDonutSvgController extends AdvancedController {

  static targets = [ 
  ];

  static values = {
  }

  doughnut;
  percentage;

  connect() {
    super.connect(...arguments)
    
    this.doughnut = document.getElementById("Doughnut")
    this.percentage = document.getElementById("Percentage")

    const len = this.doughnut.getTotalLength(); 
    this.doughnut.style.strokeDasharray = len;
    this.doughnut.style.strokeDashoffset = len;
    this.doughnut.style.opacity = 1
  }

  inViewport() {
    let tl = gsap.timeline();

    tl.to(this.doughnut, {
        strokeDashoffset: 0,
        duration: 2,
      })
      .to(this.percentage, {
          opacity: 1,
          duration: 1,
        },
        "<0.5"
      )
  }
}
